// WCAG 2 relative luminance of a #rrggbb colour, from 0 (black) to 1 (white).
const luminance = (hex: string) => {
  const n = parseInt(hex.slice(1, 7), 16);
  const channel = (c: number) => {
    const s = c / 255;
    return s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * channel(n >> 16) + 0.7152 * channel((n >> 8) & 255) + 0.0722 * channel(n & 255);
};

/** The WCAG contrast of white text on a #rrggbb background, from 1 to 21. */
export const whiteContrast = (bg: string) => 1.05 / (luminance(bg) + 0.05);

/**
 * The text colour for a tag filled with `bg` (#rrggbb). White whenever it reaches
 * 3:1, WCAG's floor for large text and UI parts (tag text is medium weight), so most
 * colours keep white text; black on light ones (yellow, light green, pastels), where
 * white would be hard to read.
 */
export const textOn = (bg: string) => (whiteContrast(bg) >= 3 ? 'text-white' : 'text-black');
